"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var MarkerShape = Object.freeze({
  Circle: "Points",
  Line: "Lines",
  Rect: "Rectangles",
  Ellipse: "Ellipses",
  Polygon: "Polygons"
});
var _default = exports.default = MarkerShape;